var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column p-5"},[_c('h5',{staticClass:"border-bottom pb-3"},[_vm._v("Mon panier")]),_vm._l((_vm.cart),function(item){return _c('cart-product-item',{key:item.id,attrs:{"item":item}})}),(_vm.cart.length)?[_c('hr',{staticClass:"w-100"}),_c('span',[_vm._v("Total : "+_vm._s(_vm.total)+" €")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }